export const deploymentCatalog = {
  media_upload: { label: '媒体上传及自动转写', reason: '当前站点未启用后台媒体处理服务。' },
  media_translation: { label: '媒体字幕翻译', reason: '字幕翻译需要后台媒体任务队列。' },
  media_timeline: { label: '逐词时间轴重建', reason: '时间轴重建需要后台媒体任务队列。' },
  media_export: { label: '音视频重组与 TTS 合成导出', reason: '媒体合成需要 FFmpeg 后台处理服务。' },
  pronunciation: { label: '专项发音评测', reason: '请先验证当前后端发音评测通道，再开启此功能。' },
} as const
export type DeploymentFeature = keyof typeof deploymentCatalog
export type DeploymentSetting = { feature: DeploymentFeature; enabled: boolean; reason: string }
export const defaultDeploymentSettings = (): DeploymentSetting[] =>
  (Object.keys(deploymentCatalog) as DeploymentFeature[]).map(feature => ({ feature, enabled: false, reason: deploymentCatalog[feature].reason }))

export function controlledFeature(name: string, body: Record<string, unknown>): DeploymentFeature | null {
  if (name === 'pronunciation-assess') return 'pronunciation'
  if (name !== 'media-learning') return null
  switch (body.action) {
    case 'reserve-upload': case 'upload-complete': case 'retry-transcription': return 'media_upload'
    case 'translate-project': return 'media_translation'
    case 'translation-toggle': return body.enabled === false ? null : 'media_translation'
    case 'timeline-rebuild': return 'media_timeline'
    case 'export-create': return 'media_export'
    default: return null
  }
}
